import React from 'react'

import { useTranslation } from 'react-i18next'

import useOutsideClick from '@hooks/useOutsideClick'
import Divider from '@layout/Divider'
import { useSession } from '@stores/globalData/globalData.store'
import PageRoutes from '@utils/page-routes'

import LocaleSelector from './LocaleSelector'
import MenuItem from './MenuItem'
import ThemeSelector from './ThemeSelector'

interface Props {
  onClose: () => void
}

const ProfileMenu: React.FC<Props> = ({ onClose }: Props) => {
  const { t } = useTranslation()
  const session = useSession()

  const ref = useOutsideClick<HTMLDivElement>(onClose)

  if (!session.current_user) return null
  return (
    <div
      ref={ref}
      className="absolute top-full right-0 bg-white dark:bg-black-bg2 z-30 shadow-thick rounded-md border-gray dark:border-gray-border-dm border mt-[-0.25rem] mr-2 py-4 px-2.5 flex flex-col min-w-[220px]">
      <p className="px-2.5 mb-2.5 text-md font-medium text-black dark:text-gray">
        {session.current_user.username}
      </p>

      <MenuItem
        label={t('userSidebar.profile')}
        href={PageRoutes.userProfilePath(session.current_user.external_id)}
      />
      <MenuItem label={t('userSidebar.account')} href={PageRoutes.accountDetailsPath()} />
      <ThemeSelector />
      <LocaleSelector />
      <Divider dark narrow />
      <MenuItem
        label={t('userSidebar.logout')}
        href={PageRoutes.logoutPath()}
        colorClass="text-orange hover:bg-orange/10 dark:hover:bg-orange/10"
        noSpacingAfter
      />
    </div>
  )
}

export default ProfileMenu
